export * from './entity-activity-information.interface';
